export default {
  'fields.name.captcha': 'Captcha',
  'fields.name.password': 'Login password',
  'fields.name.paypass': 'Pay password',
  'fields.name.oldpassword': 'Old login password',
  'fields.name.newpassword': 'New login password',
  'fields.name.confirmpassword': 'Confirm login password',
  'fields.error.newpassword.confirmpassword': 'Please confirm if the new login password matches!',
  'fields.name.oldpaypass': 'Old pay password',
  'fields.name.newpaypass': 'New pay password',
  'fields.name.confirmpaypass': 'Confirm pay password',
  'fields.error.newpaypass.confirmpaypass': 'Please confirm if the new payment password is consistent!',
};